// Generate code from clean architecture template

import { OperationMethodTable } from '../entities';
import { QueryOperationMethodPayload } from '../ports/payloads';
import { OperationMethodRepository } from '../ports/repositories';

export class FindAllOperationMethodUsecase {
  constructor(private readonly repo: OperationMethodRepository) {}

  async run(payload?: QueryOperationMethodPayload): Promise<OperationMethodTable[]> {
    const data = await this.repo.getListOperationMethod(payload);
    return data;
  }
}
